import Carousel from './carousel';

class NewsCarousel extends Carousel {

  constructor() {
    super( NewsCarousel.getCarouselElements(), {
      dots: true,
      rows: 0,

      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      infinite: true,
      centerPadding: '40px',
      responsive: [
        {
          breakpoint: 860,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },{
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  static getCarouselElements() {
    return document.querySelectorAll('.news-carousel');
  }

}

export default {
  NewsCarousel
}

export {
  NewsCarousel
}
